export default "__VITE_ASSET__CZD$WqCs__"